module.exports = __webpack_public_path__ + "img/9.e2b836bf.jpg";